<template>
	<div>
		<b-card>
			<b-card-text>
				<visualization-chart-menu-bar
					:chartType="chartType"
					:setChartType="setChartType"
				/>

				<visualization-bar-chart
					v-show="chartType === 'bar'"
					:choosenDimensions="choosenDimensions"
					:choosenData="choosenData"
					:datasetName="datasetName"
				/>

				<visualization-pyramid-chart
					v-show="chartType === 'pyramid'"
					:choosenDimensions="choosenDimensions"
					:choosenData="choosenData"
					:datasetName="datasetName"
				/>

				<visualization-cylinder-chart
					v-show="chartType === 'cylinder'"
					:choosenDimensions="choosenDimensions"
					:choosenData="choosenData"
					:datasetName="datasetName"
				/>

				<visualization-area-chart
					v-show="chartType === 'area'"
					:choosenDimensions="choosenDimensions"
					:choosenData="choosenData"
					:datasetName="datasetName"
				/>

				<visualization-line-chart
					v-show="chartType === 'line'"
					:choosenDimensions="choosenDimensions"
					:choosenData="choosenData"
					:datasetName="datasetName"
				/>

				<visualization-pie-chart
					v-show="chartType === 'pie'"
					:choosenDimensions="choosenDimensions"
					:choosenData="choosenData"
					:datasetName="datasetName"
				/>
			</b-card-text>
		</b-card>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import VisualizationChartMenuBar from "../VisualizationMainContainer/VisualizationChartContainer/VisualizationChartMenuBar.vue";
import VisualizationBarChart from "../VisualizationMainContainer/VisualizationChartContainer/VisualizationBarChart.vue";
import VisualizationPyramidChart from "../VisualizationMainContainer/VisualizationChartContainer/VisualizationPyramidChart.vue";
import VisualizationCylinderChart from "../VisualizationMainContainer/VisualizationChartContainer/VisualizationCylinderChart.vue";
import VisualizationAreaChart from "../VisualizationMainContainer/VisualizationChartContainer/VisualizationAreaChart.vue";
import VisualizationLineChart from "../VisualizationMainContainer/VisualizationChartContainer/VisualizationLineChart.vue";
import VisualizationPieChart from "../VisualizationMainContainer/VisualizationChartContainer/VisualizationPieChart.vue";

//local registration for output component
export default {
	name: "VisualizationChartContainer",
	data() {
		return {
			chartType: "bar",
		};
	},
	props: [
		"choosenData",
		"isProcessingNow", //not used
		"choosenDimensions",
		"selectedDataList",
		"choosenDataIdx",
	],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {
		datasetName() {
			if (this.choosenDataIdx === null) {
				return "";
			} else {
				return this.selectedDataList[this.choosenDataIdx].selectedDataset.name;
			}
		},
	},
	watch: {
		choosenDataIdx(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.chartType = "bar";
			}
		},
	},
	methods: {
		setChartType(val) {
			this.chartType = val;
		},
	},
	components: {
		"visualization-chart-menu-bar": VisualizationChartMenuBar,
		"visualization-bar-chart": VisualizationBarChart,
		"visualization-pyramid-chart": VisualizationPyramidChart,
		"visualization-cylinder-chart": VisualizationCylinderChart,
		"visualization-area-chart": VisualizationAreaChart,
		"visualization-line-chart": VisualizationLineChart,
		"visualization-pie-chart": VisualizationPieChart,
	},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 21-09-2022 -->
